import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js';
import React from 'react';
import { Pie } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = ({ data }) => {
  const pieData = {
    labels: Object.keys(data),
    datasets: [
      {
        data: Object.values(data),
        backgroundColor: ['#43aca1', '#a9519c', '#f5aa51'],
        borderColor: ['#149789', '#932683', '#f29526'],
        borderWidth: 1,
      },
    ],
  };

  return (
    <div className='piechart-container'>
      <h3>Información de pagos por medio de pago</h3>
      <div className='pie'>
        <Pie data={pieData} />
      </div>
    </div>
  );
};

export default PieChart;
